export default "__VITE_ASSET__BDXLxZGc__"